import React, { useState, useContext } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import alertify from "alertifyjs";
import { useApolloClient, useMutation } from "@apollo/react-hooks";
import { makeStyles } from "@material-ui/core/styles";
import { Loading } from "../components";
import { userMutations } from "../resolvers";
import { MainContext } from "../../contexts";

const options = {
  userNameType: "email",
  userNameText: "Email Adresi",
  passwordText: "Parola",
  caption: "Başlayalım",
  rememberIsActive: true,
  rememberMe: "Beni Hatırla",
  forgotPasswordIsActive: true,
  forgotPassword: "Parolamı Unuttum",
  forgotPasswordHref: "signforgotpass",
  signUpIsActive: true,
  signUp: "Kayıt Ol",
  signUpHref: "signup",
  buttonText: "Giriş",
};

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit">Tüm Hakları Saklıdır -</Link>{" "}
      {new Date().getFullYear()}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: "4em",
  },
}));

export default function SignIn({ handleChangeState }) {
  const [initialState, setInitialStates] = useState({
    username: "",
    password: "",
    error: {},
  });
  const resetInitialState = () => {
    setInitialStates({
      username: "",
      password: "",
      error: {},
    });
  };
  const classes = useStyles();

  const validate = () => {
    const { username, password } = initialState;
    setInitialStates({
      ...initialState,
      error: {
        username: username ? false : true,
        password: password ? false : true,
      },
    });
    return !username || !password;
  };

  const onChange = (event) => {
    setInitialStates({
      ...initialState,
      [event.target.name]: event.target.value,
      error: {
        ...initialState.error,
        [event.target.name]: event.target.value ? false : true,
      },
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      alertify.error("Kullanıcı Adı veya Parola Boş Olamaz", 3);
    } else {
      signin({
        variables: {
          username: initialState.username,
          password: initialState.password,
        },
      });
    }
  };
  //const { state, setState } = useContext(MainContext);

  const client = useApolloClient();
  const [signin, { loading }] = useMutation(userMutations.LOGIN, {
    onCompleted({ login }) {
      localStorage.setItem("token", login.token);
      client.cache.reset();
      client.writeData({
        data: {
          isLoggedIn: true,
        },
      });
      resetInitialState();
      alertify.success("Başarıyla Giriş Sağlandı", 2);
    },
    onError(err) {
      let x = err.message.split(":", 2);
      alertify.error(x[1], 3);
    },
  });

  if (loading) return <Loading />;

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        {/*<Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {options.caption}
        </Typography>*/}
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            error={initialState.error.username}
            onChange={onChange}
            variant="outlined"
            margin="normal"
            fullWidth
            value={initialState.username}
            id="username"
            label={options.userNameText}
            name="username"
            autoComplete={options.userNameType}
            autoFocus
          />
          <TextField
            error={initialState.error.password}
            onChange={onChange}
            variant="outlined"
            margin="normal"
            fullWidth
            value={initialState.password}
            name="password"
            label={options.passwordText}
            type="password"
            id="password"
            autoComplete="current-password"
          />
          {/*options.rememberIsActive && (
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label={options.rememberMe}
              />
            )*/}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            {options.buttonText}
          </Button>

          {false && (
            <Grid container>
              {options.forgotPasswordIsActive && (
                <Grid item xs>
                  <Link
                    component="button"
                    variant="body2"
                    onClick={() => handleChangeState("forgot")}
                  >
                    {options.forgotPassword}
                  </Link>
                </Grid>
              )}
            </Grid>
          )}
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
